import { render, staticRenderFns } from "./basic-account.vue?vue&type=template&id=c0ba8e8e&scoped=true&"
import script from "./basic-account.vue?vue&type=script&lang=js&"
export * from "./basic-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ba8e8e",
  null
  
)

export default component.exports